/**
 * Copyright (C) 2021 - 2025 Philips Domestic Appliances Holding B.V.
 * All rights are reserved.
 */

import { inject, Injectable } from '@angular/core';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { AppTitleService } from '../../services/app-title/app-title.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class AppTitleStrategy extends TitleStrategy {
	private readonly appTitleService = inject(AppTitleService);
	private readonly translateService = inject(TranslateService);

	private lastPath: string | null = null;

	public updateTitle(snapshot: RouterStateSnapshot): void {
		const currentPath = snapshot.url.split('?')[0]; // Strip query params

		// Ignore if non-query path hasn't changed
		if (currentPath === this.lastPath) {
			return;
		}

		this.lastPath = currentPath;
		const titleKey = this.buildTitle(snapshot);
		const title = titleKey ? this.translateService.instant(titleKey) : '';
		this.appTitleService.updateTitle(title);
	}
}
